/**
 * Renders a Builder.io "page" model entry with our custom component registry.
 *
 * Shared by the `/page/$name` catch-all and the clean-URL marketing routes
 * (`/about`, `/how-it-works`, …) so Builder content renders identically
 * wherever it is mounted.
 *
 * Aliases: builder content renderer, builder page body
 */

import { type BuilderContent, Content } from "@builder.io/sdk-react/edge";
import { useEffect } from "react";

import {
  CUSTOM_COMPONENTS,
  configureBuilder,
} from "~/components/builder-registry";
import { useConsent } from "~/contexts/consent";
import { BUILDER_PAGE_MODEL } from "~/lib/builder/page";
import { clientEnv } from "~/lib/utils/client-env";

export function BuilderPage({ content }: { content: BuilderContent }) {
  const { allowed } = useConsent();

  useEffect(() => {
    configureBuilder();
  }, []);

  return (
    <Content
      model={BUILDER_PAGE_MODEL}
      content={content}
      apiKey={clientEnv.VITE_BUILDER_API_KEY}
      customComponents={CUSTOM_COMPONENTS}
      canTrack={allowed.analytics}
    />
  );
}
